// Routes.js
import React, { Suspense, lazy } from 'react';
import {
  Route,
  Outlet,
  Navigate,
  BrowserRouter as Router,
  Routes,
} from 'react-router-dom';
import Loading from '../components/Loading/Loading';
import { filterRoutes, transformPermissions } from '../hooks/use-permission';
import { useSelector } from 'react-redux';
import ProtectedRoutes from './ProtectedRoutes';

const RootLayout = lazy(() => import('../pages/Root'));

// HOME PAGE
const DashboardPage = lazy(() => import('../pages/dashboard/Dashboard'));
const SubscribePage = lazy(() => import('../pages/subscription/SubscribePage'));

// PRODUCT MANAGEMENT
const ProductManagement = lazy(() =>
  import('../pages/productManagement/stock-products/list/StockProducts')
);

const EditProduct = lazy(() =>
  import('../pages/productManagement/stock-products/view/EditProduct')
);

const AddProduct = lazy(() =>
  import('../pages/productManagement/stock-products/list/AddProduct')
);

const OfferPage = lazy(() => import('../pages/productManagement/offers/index'));
const GenericOfferPage = lazy(() =>
  import('../pages/productManagement/offers/genericOffer/index')
);
const ProductSpecificOfferPage = lazy(() =>
  import('../pages/productManagement/offers/productSpecificOffer/index')
);

const ListOfServices = lazy(() =>
  import('../pages/productManagement/LIstOfServices/List/index')
);

const ViewListedServices = lazy(() =>
  import('../pages/productManagement/stock-products/view/EditProduct')
);

const AddServises = lazy(() =>
  import('../pages/productManagement/stock-products/list/AddProduct')
);

// AUTH
const AuthLayout = lazy(() => import('../pages/auth'));
const LoginPage = lazy(() => import('../pages/auth/login'));

// SALES
const SalesOrder = lazy(() => import('../pages/sales/salesOrder/List'));
const SalesInvoice = lazy(() =>
  import('../pages/sales/salesInvoice/List/index')
);
const Quotation = lazy(() => import('../pages/sales/quotations/List'));

const CreateSalesOrder = lazy(() =>
  import('../pages/sales/salesOrder/createOrder')
);
const EditSalesOrder = lazy(() =>
  import('../pages/sales/salesOrder/createOrder')
);
const ViewSalesOrder = lazy(() =>
  import('../pages/sales/salesOrder/view/view-edit/ViewSalesOrder')
);

// ------------------------Quotations--------------
const CreateQuotation = lazy(() =>
  import('../pages/sales/quotations/createQuotation')
);
const EditQuotation = lazy(() =>
  import('../pages/sales/quotations/createQuotation')
);
const ViewQuotation = lazy(() =>
  import('../pages/sales/quotations/view/view-edit/ViewQuotation')
);
// -----------------------Sales Invoice---------------
const ViewInvoice = lazy(() =>
  import('../pages/sales/salesInvoice/view/index')
);

const MakePayment = lazy(() =>
  import('../pages/sales/salesInvoice/view/makePayment')
);

const AddCustomer = lazy(() =>
  import('../pages/sales/customers/addCustomer/AddCustomer')
);
const CustomerList = lazy(() =>
  import('../pages/sales/customers/List/CustomerList')
);

const CreateInvoice = lazy(() =>
  import('../pages/sales/salesInvoice/createInvoice/index')
);

// Sales Target
const SalesTargetList = lazy(() =>
  import('../pages/sales/salesTarget/List/salesTargetHomePage')
);

const CreateSalesTarget = lazy(() =>
  import('../pages/sales/salesTarget/createSalesTarget/CreateSalesTarget')
);

const ViewSalesTarget = lazy(() =>
  import(
    '../pages/sales/salesTarget/viewOrEditSalesTarget/ViewOrEditSalesTarget'
  )
);

//Wallet
const UserWalletCustomerList = lazy(() =>
  import('../pages/sales/User wallet/UserWalleCustomertList')
);

//SERVICES

// Service Request

const ServiceList = lazy(() => import('../pages/service/ServiceList/index'));
const ServiceRequest = lazy(() =>
  import('../pages/service/serviceRequest/List/index')
);

const ServiceRequestView = lazy(() =>
  import('../pages/service/serviceRequest/View/index')
);

const CreateserviceRequest = lazy(() =>
  import('../pages/service/serviceRequest/CreateServiceRequest/index')
);

//JOB CARD
const CreateJobCardFromSerivceReq = lazy(() =>
  import('../pages/service/jobCard/CreateJobCard/index')
);

const JobCard = lazy(() => import('../pages/service/jobCard/List/index'));

const ViewJobCard = lazy(() =>
  import('../pages/service/jobCard/view/view-edit/ViewSalesOrder')
);

const EditJobCard = lazy(() =>
  import('../pages/service/jobCard/CreateJobCard')
);
// const EditSalesOrder = lazy(() =>
//   import("../pages/sales/salesOrder/createOrder")
// );

const ServiceRequestInvoice = lazy(() =>
  import('../pages/service/serviceRequestInvoice/index')
);

// PURCHASE
const PurchaseOrder = lazy(() =>
  import('../pages/purchase/purchaseOrder/List/index')
);
const CreatePurchaseOrder = lazy(() =>
  import('../pages/purchase/purchaseOrder/createOrder')
);
const EditPurchaseOrder = lazy(() =>
  import('../pages/purchase/purchaseOrder/createOrder')
);
const ViewPurchaseOrder = lazy(() =>
  import('../pages/purchase/purchaseOrder/view/view-edit/ViewPurchaseOrder')
);

//PURCHASE ORDER BY CUSTOMER
const PurchaseOrderFromCustomer = lazy(() =>
  import('../pages/purchase/poFromCustomer/List/index')
);
const CreatePurchaseOrderFromCustomer = lazy(() =>
  import('../pages/purchase/poFromCustomer/createOrder')
);
const EditPurchaseOrderFromCustomer = lazy(() =>
  import('../pages/purchase/poFromCustomer/createOrder')
);
const ViewPurchaseOrderFromCustomer = lazy(() =>
  import('../pages/purchase/poFromCustomer/view/view-edit/ViewPurchaseOrder')
);

const AddVendor = lazy(() =>
  import('../pages/purchase/vendors/addVendor/AddVendor')
);
const VendorList = lazy(() =>
  import('../pages/purchase/vendors/List/VendorList')
);

const PurchaseBill = lazy(() =>
  import('../pages/purchase/purchaseBill/List/index')
);

const ViewBill = lazy(() =>
  import('../pages/purchase/purchaseBill/view/index')
);

const MakeNillPayment = lazy(() =>
  import('../pages/purchase/purchaseBill/view/makePayment/index')
);

// REPORTS
const InventoryReports = lazy(() =>
  import('../pages/reports/inventory/catalogList/InventoryList')
);
const InventoryListing = lazy(() =>
  import('../pages/reports/inventory/productList/StockProducts')
);
const SalesReport = lazy(() =>
  import('../pages/reports/salesReport/SalesReport')
);
const ProfitLossReports = lazy(() =>
  import('../pages/reports/profitLoss/SalesAndProfitReport')
);

const TaxReport = lazy(() => import('../pages/reports/taxReport/List/TaxList'));

const Payments = lazy(() => import('../pages/receivables/payments/List/index'));
const ReceivablesInvoice = lazy(() =>
  import('../pages/receivables/receivablesInvoice/List/index')
);

const SalesTargetReport = lazy(() =>
  import('../pages/reports/salesTargetReport/SalesTargetReportList')
);

const SalesTargetReportGraph = lazy(() =>
  import('../pages/reports/salesTargetReport/SalesTargetGraph')
);

const LadgerReport = lazy(() =>
  import('../pages/reports/ladgerReport/LadgerReport')
);

// SETTINGS
const TenantInfo = lazy(() => import('../pages/admin/tenantInfo/index'));

const CreateUserPage = lazy(() => import('../pages/admin/users/createUser'));
const Users = lazy(() => import('../pages/admin/users/List/UserList'));
const ViewUser = lazy(() => import('../pages/admin/users/View/ViewUser'));
const MyPackage = lazy(() => import('../pages/admin/LoggedInUserPackage/Page'));
const AddExpenses = lazy(() => import('../pages/admin/AddExpenses/index'));
const BusinessSettings = lazy(() =>
  import('../pages/admin/BusinessSettings/index')
);
const EmployeeList = lazy(() => import("../pages/admin/employes/index"));
const AddEmployee = lazy(() => import('../pages/admin/employes/AddEmployee/AddEmployee'));

const EmployeeExpensesList = lazy(() => import('../pages/admin/employes/EmployeeExpenses/List'));

//SUPER-ADMIN
const PackageCreation = lazy(() =>
  import('../pages/superAdmin/package/packageCreation/PackageCreation')
);
const PackageListing = lazy(() =>
  import('../pages/superAdmin/package/packageListing/index')
);
const SubscriptionListing = lazy(() =>
  import('../pages/superAdmin/subscriptions/subscriptionListing/index')
);
const TenantListing = lazy(() =>
  import('../pages/superAdmin/tenant/tenantListing/index')
);
const TransactionsList = lazy(() =>
  import('../pages/superAdmin/transactionsList/index')
);

const CreateTenantPage = lazy(() => import('../pages/auth/createTenant'));

const InitialPasswordChange = lazy(() =>
  import('../components/ChangeInitialPassword/Page')
);

//SERVICE REQUEST PAGE
const ServiceRequestPage = lazy(() =>
  import('../pages/auth/ServiceRequest/serviceRequestPage')
);

const ServiceRequestiframes = lazy(() =>
  import('../pages/auth/ServiceRequest/index')
);

// PROTECTED ROUTES

//SUPER_ADMIN_ROUTES

const SUPER_ADMIN_ROUTES = (
  <>
    <Route path="/" element={<RootLayout />}>
      <Route path="/" element={<DashboardPage />} />

      <Route path="product-management" element={<Outlet />}>
        <Route path="Stocked-Products" element={<Outlet />}>
          <Route index element={<ProductManagement />} />
          <Route path="view" element={<EditProduct />} />
          <Route path="edit" element={<EditProduct />} />
          <Route path="add-product" element={<AddProduct />} />
        </Route>
        <Route path="offer" element={<Outlet />}>
          <Route index element={<OfferPage />} />
          <Route path="view" element={<EditProduct />} />
          <Route path="edit" element={<EditProduct />} />
          <Route path="generic-offer" element={<GenericOfferPage />} />
          <Route
            path="product-specific-offer"
            element={<ProductSpecificOfferPage />}
          />
        </Route>
      </Route>

      <Route path="sales" element={<Outlet />}>
        <Route path="order" element={<Outlet />}>
          <Route index element={<SalesOrder />} />
          <Route path="create" element={<CreateSalesOrder />} />
          <Route path="view" element={<ViewSalesOrder />} />
          <Route path="edit" element={<EditSalesOrder />} />
        </Route>

        <Route path="customers" element={<Outlet />}>
          <Route index element={<CustomerList title="Customer" />} />
          <Route path="add" element={<AddCustomer />} />
        </Route>

        <Route path="invoices" element={<Outlet />}>
          <Route index element={<SalesInvoice />} />
          <Route path="view" element={<Outlet />}>
            <Route index element={<ViewInvoice />} />
            <Route path="make-payments" element={<MakePayment />} />
          </Route>
        </Route>

        <Route path="quotations" element={<Outlet />}>
          <Route index element={<Quotation />} />
          <Route path="create" element={<CreateQuotation />} />
          <Route path="view" element={<ViewQuotation />} />
          <Route path="edit" element={<EditQuotation />} />
        </Route>
      </Route>

      <Route path="services" element={<Outlet />}>
        <Route path="service-list" element={<Outlet />}>
          <Route index element={<ServiceList />} />
        </Route>

        <Route path="service-request" element={<Outlet />}>
          <Route index element={<ServiceRequest />} />
          <Route path="create" element={<CreateserviceRequest />} />
          <Route path="view" element={<ServiceRequestView />} />
        </Route>

        <Route path="job-card" element={<Outlet />}>
          <Route index element={<JobCard />} />
          <Route path="create" element={<CreateJobCardFromSerivceReq />} />
          <Route path="view" element={<ViewJobCard />} />
          <Route path="edit" element={<EditJobCard />} />
        </Route>
        <Route path="invoices" element={<Outlet />}>
          <Route index element={<ServiceRequestInvoice />} />
        </Route>
      </Route>

      <Route path="purchase" element={<Outlet />}>
        <Route path="from-customer" element={<Outlet />}>
          <Route index element={<PurchaseOrderFromCustomer />} />
          <Route path="create" element={<CreatePurchaseOrderFromCustomer />} />
          <Route path="view" element={<ViewPurchaseOrderFromCustomer />} />
          <Route path="edit" element={<EditPurchaseOrderFromCustomer />} />
        </Route>
        <Route path="order" element={<Outlet />}>
          <Route index element={<PurchaseOrder />} />
          <Route path="create" element={<CreatePurchaseOrder />} />
          <Route path="view" element={<ViewPurchaseOrder />} />
          <Route path="edit" element={<EditPurchaseOrder />} />
        </Route>
        <Route path="vendors" element={<Outlet />}>
          <Route index element={<VendorList title="Vendor" />} />
          <Route path="add" element={<AddVendor />} />
        </Route>
        <Route path="bills" element={<Outlet />}>
          <Route index element={<PurchaseBill />} />
          <Route path="view" element={<Outlet />}>
            <Route index element={<ViewBill />} />
            <Route path="make-payments" element={<MakeNillPayment />} />
          </Route>
        </Route>
      </Route>

      <Route path="receivables" element={<Outlet />}>
        <Route path="invoices" element={<Outlet />}>
          <Route index element={<ReceivablesInvoice />} />
        </Route>
        <Route path="payments" element={<Payments />} />
      </Route>

      <Route path="reports" element={<Outlet />}>
        <Route path="inventory-report" element={<Outlet />}>
          <Route index element={<InventoryReports />} />
          <Route path="list" element={<InventoryListing />} />
        </Route>
        <Route path="sales-report" element={<SalesReport />} />
        <Route path="tax-report" element={<TaxReport />} />
        <Route path="profit-loss-report" element={<ProfitLossReports />} />
      </Route>

      <Route path="admin" element={<Outlet />}>
        <Route path="users" element={<Outlet />}>
          <Route index element={<Users />} />
          <Route path="create" element={<CreateUserPage />} />
          <Route path="view" element={<ViewUser />} />
        </Route>
        <Route path="employees" element={<Outlet />}>
          <Route index element={<EmployeeList />} />
          <Route path="create" element={<AddEmployee />} />
        </Route>
        <Route path="employees-expenses" element={<Outlet />}>
          <Route index element={<EmployeeExpensesList />} />
          {/* <Route path="create" element={<AddEmployee />} /> */}
        </Route>
        <Route path="business" element={<Outlet />}>
          <Route index element={<TenantInfo />} />
        </Route>

        <Route path="my-package" element={<MyPackage />}></Route>
        <Route path="expenses" element={<AddExpenses />}></Route>
      </Route>

      <Route path="super-admin" element={<Outlet />}>
        <Route path="package" element={<Outlet />}>
          <Route index element={<PackageListing />} />
          <Route path="create" element={<PackageCreation />} />
          <Route path="view" element={<PackageCreation />} />
        </Route>
        <Route path="subscription" element={<SubscriptionListing />}></Route>
        <Route path="tenant" element={<Outlet />}>
          <Route index element={<TenantListing />} />
          <Route path="create" element={<CreateTenantPage />} />
          <Route path="transactions-list" element={<TransactionsList />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" />} />
    </Route>
    <Route path="/service-request-page" element={<ServiceRequestPage />} />
  </>
);

// UNPROTECTED ROUTES
const UNPROTECTED_ROUTES = (
  <>
    {/* Routes without AuthLayout */}
    <Route
      path="/service-request-iframes"
      element={<ServiceRequestiframes />}
    />
    <Route path="/service-request-page" element={<ServiceRequestPage />} />

    {/* Routes with AuthLayout */}
    <Route path="/" element={<AuthLayout />}>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="login" element={<LoginPage />} />
      <Route
        path="change-initial-password"
        element={<InitialPasswordChange />}
      />
      <Route path="subscribe" element={<SubscribePage />} />
      <Route path="*" element={<Navigate to="/login" />} />
    </Route>
  </>
);

const AppRoutes = ({ isAuthenticated, userRole }) => {
  return (
    <Router>
      <Suspense fallback={<Loading />}>
        <Routes>
          {isAuthenticated
            ? userRole === 'SUPER_ADMIN'
              ? SUPER_ADMIN_ROUTES
              : ProtectedRoutes()
            : UNPROTECTED_ROUTES}
        </Routes>
      </Suspense>
    </Router>
  );
};

// function Loading(props) {
// 	return (
// 		<div className="App">
// 			<Header signOut={props.signOut} />
// 			<div className="main-container">
// 				<center>Loading... </center>
// 			</div>
// 		</div>
// 	);
// }

export default AppRoutes;
